// @ts-nocheck
import { MONITORING_API_ENDPOINT, ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT } from '../config';
import { catchAsync } from '../utils/api';
import axios from '../utils/axios';

const blockTicketPayment = catchAsync(async params => {
    const result = await axios.put(`${MONITORING_API_ENDPOINT}/ticket/block`, params);

    return result.data;
});

const getActionBlockData = catchAsync(async () => {
    const response = await axios.get(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/operation-setting/all`);

    return response.data;
});

const updateActionBlock = catchAsync(async data => {
    const response = await axios.put(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/operation-setting`, data);

    return response.data;
});

const cancelTicketPayment = catchAsync(async params => {
    const result = await axios.put(`${MONITORING_API_ENDPOINT}/tickets/cancel`, params);

    return result.data;
});

const TicketsService = {
    blockTicketPayment,
    getActionBlockData,
    updateActionBlock,
    cancelTicketPayment,
};

export default TicketsService;
